import { createElementVNode as _createElementVNode, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-80aac146"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  id: "faq",
  class: "com-div clearfix extension-index"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "extension-title ac"
}, "Extensible and customizable", -1));

const _hoisted_3 = {
  class: "extension-input"
};
const _hoisted_4 = {
  class: "extension-list"
};
const _hoisted_5 = {
  class: "extension-info"
};
const _hoisted_6 = {
  class: "extension-logo"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  class: "extension-name ac ellipise"
};
const _hoisted_9 = {
  class: "extension-author ac"
};
const _hoisted_10 = ["src"];
const _hoisted_11 = {
  class: "lh22"
};
const _hoisted_12 = {
  class: "cover"
};
const _hoisted_13 = ["href"];

const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icondownload-01"
}, null, -1));

const _hoisted_15 = /*#__PURE__*/_createTextVNode("Download");

const _hoisted_16 = [_hoisted_14, _hoisted_15];
const _hoisted_17 = {
  class: "extension-version clearfix"
};
const _hoisted_18 = {
  class: "fl"
};

const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icondownload-01"
}, null, -1));

const _hoisted_20 = {
  class: "fr"
};

const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont iconversion-01"
}, null, -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", null, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_withDirectives(_createElementVNode("input", {
    type: "text",
    placeholder: "Search",
    id: "key-inp",
    onKeydown: _cache[0] || (_cache[0] = _withKeys( //@ts-ignore
    (...args) => _ctx.getPluginsFn && _ctx.getPluginsFn(...args), ["enter"])),
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.keyword = $event)
  }, null, 544), [[_vModelText, _ctx.keyword]]), _createElementVNode("i", {
    class: "iconfont iconfangdajing",
    onClick: _cache[2] || (_cache[2] = //@ts-ignore
    (...args) => _ctx.getPluginsFn && _ctx.getPluginsFn(...args))
  })]), _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pluginsList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "extension-item",
      key: index
    }, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("img", {
      src: item.icon,
      class: "width65 height65"
    }, null, 8, _hoisted_7)]), _createElementVNode("div", _hoisted_8, _toDisplayString(item.name), 1), _createElementVNode("div", _hoisted_9, [_createElementVNode("img", {
      src: item.userImg,
      class: "width22",
      onError: _cache[3] || (_cache[3] = //@ts-ignore
      (...args) => _ctx.headError && _ctx.headError(...args))
    }, null, 40, _hoisted_10), _createElementVNode("span", _hoisted_11, _toDisplayString(item.publisher), 1)]), _createElementVNode("span", null, _toDisplayString(item.category), 1)]), _createElementVNode("div", _hoisted_12, [_createElementVNode("a", {
      class: "ac",
      href: 'https://api.gobies.org/api/plugin-download/version_hash/' + item.version_hash
    }, _hoisted_16, 8, _hoisted_13)]), _createElementVNode("div", _hoisted_17, [_createElementVNode("span", _hoisted_18, [_hoisted_19, _createTextVNode(_toDisplayString(item.download), 1)]), _createElementVNode("span", _hoisted_20, [_hoisted_21, _createTextVNode(_toDisplayString(item.version), 1)])])]);
  }), 128))])])]);
}